/* eslint no-var: off */
/* eslint vars-on-top: off */
import { IUserResponse } from 'types/login';

declare global {
	var analytics: any | undefined;
}

enum AnalyticsActionName {
	signIn = 'Sign In',
	signUp = 'pe22419231_console_signup',
	wizardStep = 'Wizard Step',
	projectSettings = 'Project Settings',
	projectSettingsDelete = 'Project Settings Delete',
	companySettings = 'Company Settings',
	adminInvites = 'Admin Invites',
	accessKeyCreation = 'Access Key Creation',
	managementKeyCreation = 'Management Key Creation',
	authMethodsSettings = 'Auth Methods Settings',
	inviteAdminUsers = 'Invite Admin Users'
}

const getUserObject = (user?: IUserResponse) => {
	const indexOfSpace = user?.name?.indexOf(' ') || -1;
	return {
		firstName: user?.name ? user?.name.split(' ')[0] : '',
		lastName: user?.name?.substring(indexOfSpace + 1),
		name: user?.name,
		email: user?.email,
		userId: user?.userId,
		origin: 'console'
	};
};

let analyticsSingleton: any;

const obj = () => {
	if (!analyticsSingleton) {
		analyticsSingleton = {
			...analytics,
			identifyUserResponse: (user?: IUserResponse) => {
				analytics?.identify(user?.userId, getUserObject(user));
			},
			trackUserResponse: (
				actionName: `${
					| AnalyticsActionName.signIn
					| AnalyticsActionName.signUp}`,
				user?: IUserResponse
			) => {
				obj().identifyUserResponse(user);
				analytics?.track(actionName, getUserObject(user));
			},
			track: (action: AnalyticsActionName, properties?: any) => {
				analytics?.track(action, properties);
			}
		};
	}

	return analyticsSingleton;
};

export { AnalyticsActionName };
export default obj;
